<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-epigraph element-without-heading" id="intro-to-rough-draft">
<div class="text" id="intro-to-rough-draft-text">
<div class="blockquote-container prose without-attribution">
<blockquote class="prose without-attribution">
<p class="first blockquote-content blockquote-content-prose"><i>When my professional writing career was just getting under way, I was eagerly pursuing book contracts, building my name, selling stories to the major magazines, clawing myself up one step at a time. A hot new author exploded on the scene with a universally celebrated first novel, which won a bunch of awards; everybody read it, everybody talked about it.</i></p>
<p class="subsq blockquote-content blockquote-content-prose"><i>And we never heard from him again. No second novel that I knew of, no short story publications. The guy had achieved the pinnacle of success that so many of us longed for … and then he just disappeared. Why would anyone do that? The question obsessed me, and I still don’t know the answer.</i></p>
<p class="subsq blockquote-content blockquote-content-prose"><i>“Rough Draft” explores that question, and I think it’s one of my most powerful stories.</i></p>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introtoroughdraft.vue?7c721d56